// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"f57ea6fa","270":"d719f209","466":"2664a2f3","592":"ed38173f","661":"0c147224","704":"cb465249","762":"0b5073ff","837":"e1b7c60e","845":"b47683b9","859":"fa0b6b8c","960":"fbb5be88","964":"38886cad"}[chunkId] + ".chunk.js";
};